<template>
  <div class="section-modal" v-if="showModal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Add Section</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label class="font14">
          <b>Section Name</b>
        </label>
        <input type="text" class="form-control form-control-sm" v-model="editSection">
        <label class="font14">
          <input type="checkbox" v-model="editSubSection"/>
          <b>Sub-section</b>
        </label>
      </div>
      <div class="button-box float-right mr-0">
        <button class="btn btn-success" v-if="!editing" @click="addSection">Add</button>
        <button class="btn btn-success" v-else @click="saveSection">Save</button>
        <button class="btn btn-secondary" @click="closeModal">Cancel</button>
      </div>

      <!-- manage sections -->
      <br>
      <br>
      <hr>

      <h3>Manage Sections</h3>

      <table class="table table-bordered table-striped table-hover table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Label</th>
            <th>Help Text</th>
            <th># Fields</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(section, index) in sections" :key="index">
            <td>{{ section.fieldName }}</td>
            <td>{{ section.originalValue }}</td>
            <td>{{ section.desc }}</td>
            <td>{{ section.fieldsAdded !== undefined ? Object.keys(section.fieldsAdded).length : 0 }}</td>
            <td>
              <button class="btn btn-sm btn-light" @click="editSectionGroup(section)">Edit</button>
              <button class="btn btn-sm btn-danger" @click="deleteSection(section.fieldName, index)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
export default {
  name: 'section-modal',

  data () {
    return {
      showModal: false,
      editSection: '',
      addModel: false,
      editSubSection: false,
      editing: false,
      editKey: '',
      sections: []
    }
  },

  mounted () {
    let that = this
    this.$on('showModal', function () {
      that.editSection = ''
      that.editSubSection = false
      that.showModal = true
      that.editing = false
      that.sections = []

      // sections created
      let questionnaireData = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data

      Object.keys(questionnaireData).forEach(fieldKey => {
        if (questionnaireData[fieldKey].type === 'section') that.sections.push(questionnaireData[fieldKey])
      })
    })

    this.$on('showEditModal', function (data) {
      that.editSection = data.section
      that.editSubSection = data.subSection
      that.showModal = true
      that.editing = true
      that.editKey = data.index
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$off('showModal')
    this.$off('showEditModal')
  },

  methods: {
    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    closeModal () {
      this.showModal = false
    },

    addSection () {
      this.$store.commit('addSectionField', {
        label: this.editSection,
        subSection: this.editSubSection
      })
      this.$store.dispatch('saveTemplate')
      this.$bus.emit('reloadQuestionnaire')
      this.closeModal()
    },

    saveSection () {
      this.$store.commit('editSectionField', {
        index: this.editKey,
        label: this.editSection,
        subSection: this.editSubSection
      })
    },

    editSectionGroup (payload) {
      this.$bus.$emit('sectionEditModal', payload)
    },

    deleteSection (sectionName, index) {
      this.sections.splice(index, 1)

      this.$bus.$emit('removeSection', sectionName)
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-modal {
    position: fixed;
    top: 15%;
    left: 50%;
    margin-left: -25%;
    width: 50%;
    max-width: 1700px;
    min-height: 210px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      padding: 10px;
      width: 100%;
      height: 500px;
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    margin-bottom: 15px;
    .btn {
      margin-left: 10px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/SectionModal.vue